export { Inputtext } from './inputtext.component';
